import React from 'react';
import { Button } from '@cp/ds/src/components/button';
import { ButtonProps } from '@cp/ds/src/components/button/model';
import { EntityId } from '@reduxjs/toolkit';
import { useIsFavorite } from '@cp/entities/client/current/favorite/model/useIsFavorite';
import { SxProps } from '@cp/ds';
import { HeartFilledIcon } from '@cp/ds/src/icons/heartFilled';
import { HeartBoldIcon } from '@cp/ds/src/icons/heartBold';
import { useQueryFavorites, useToggleFavorite } from '../model';

export interface ToggleButtonProps extends ButtonProps {
  clientId: EntityId;
  itemSx?: SxProps;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({ clientId, ...props }) => {
  const { isFavoritesLoading } = useQueryFavorites();
  const isFavorite = useIsFavorite(clientId);
  const onClick = useToggleFavorite(clientId);

  return (
    <Button disabled={isFavoritesLoading} onClick={onClick} square sx={{ color: isFavorite ? 'pink' : 'gray' }} type="button" {...props}>
      {isFavorite ? <HeartFilledIcon /> : <HeartBoldIcon />}
    </Button>
  );
};
